// @ts-nocheck
(function () {
  // Prevent this script from running multiple times if the asset is included
  // more than once (e.g. in core bundle + section bundle).
  if (window.__mfDynamicMenuScriptInitialized) return;
  window.__mfDynamicMenuScriptInitialized = true;

  const DROPDOWN_CLOSE_DELAY_MS = 120;
  const NESTED_DROPDOWN_CLOSE_DELAY_MS = 200;

  class DynamicMenuBlock {
    constructor(root) {
      this.root = root;
      this.nav = root.querySelector('.navbar__nav');
      this.init();
    }

    init() {
      if (!this.nav) return;

      this.initDropdowns();
      this.initNestedDropdowns();

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeAllDropdowns();
        }
      });

      window.addEventListener('resize', () => {
        this.repositionOpenDropdowns();
      });
    }

    isColumnLayout() {
      return this.root.classList.contains('dynamic-menu--direction-column');
    }

    isTouchOrMobile() {
      return window.innerWidth <= 639 || 'ontouchstart' in window;
    }

    /** Hover flyouts only for row layout on non-touch desktop */
    shouldUseHoverFlyouts() {
      return !this.isColumnLayout() && !this.isTouchOrMobile();
    }

    /** Absolute positioning only for row flyouts on desktop */
    shouldPositionFlyouts() {
      return !this.isColumnLayout() && window.innerWidth > 639;
    }

    repositionOpenDropdowns() {
      if (!this.shouldPositionFlyouts()) return;

      const openDropdowns = this.root.querySelectorAll(
        '.navbar__dropdown.is-open'
      );
      openDropdowns.forEach((dropdown) => {
        const toggle = dropdown.previousElementSibling;
        if (toggle && toggle.hasAttribute('data-dropdown-toggle')) {
          this.positionDropdown(toggle, dropdown);
        }
      });

      const openNestedDropdowns = this.root.querySelectorAll(
        '.navbar__nested-dropdown.is-open'
      );
      openNestedDropdowns.forEach((nestedDropdown) => {
        const toggle = nestedDropdown.previousElementSibling;
        if (toggle && toggle.hasAttribute('data-nested-dropdown-toggle')) {
          this.positionNestedDropdown(toggle, nestedDropdown);
        }
      });
    }

    initDropdowns() {
      const dropdownToggles = this.root.querySelectorAll(
        '[data-dropdown-toggle]'
      );

      dropdownToggles.forEach((toggle) => {
        const dropdown = toggle.nextElementSibling;
        const dropdownContainer = toggle.parentElement;
        let hoverTimeout;

        if (!dropdown) return;

        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleDropdown(toggle, dropdown);
        });

        toggle.addEventListener('mouseenter', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
          this.closeAllDropdowns();
          this.openDropdown(toggle, dropdown);
        });

        toggle.addEventListener('mouseleave', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
          hoverTimeout = setTimeout(() => {
            this.closeDropdown(toggle, dropdown);
          }, DROPDOWN_CLOSE_DELAY_MS);
        });

        dropdown.addEventListener('mouseenter', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
        });

        dropdown.addEventListener('mouseleave', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
          hoverTimeout = setTimeout(() => {
            this.closeDropdown(toggle, dropdown);
          }, DROPDOWN_CLOSE_DELAY_MS);
        });

        toggle.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleDropdown(toggle, dropdown);
          } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.openDropdown(toggle, dropdown);
            const firstLink = dropdown.querySelector('.navbar__dropdown-link');
            if (firstLink) firstLink.focus();
          } else if (event.key === 'Escape') {
            this.closeDropdown(toggle, dropdown);
          }
        });

        const dropdownLinks = dropdown.querySelectorAll(
          '.navbar__dropdown-link'
        );
        dropdownLinks.forEach((link, index) => {
          link.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown') {
              event.preventDefault();
              const nextLink = dropdownLinks[index + 1];
              if (nextLink) nextLink.focus();
            } else if (event.key === 'ArrowUp') {
              event.preventDefault();
              if (index === 0) {
                toggle.focus();
              } else {
                const prevLink = dropdownLinks[index - 1];
                if (prevLink) prevLink.focus();
              }
            } else if (event.key === 'Escape') {
              event.preventDefault();
              this.closeDropdown(toggle, dropdown);
              toggle.focus();
            }
          });
        });

        document.addEventListener('click', (event) => {
          if (!dropdownContainer.contains(event.target)) {
            this.closeDropdown(toggle, dropdown);
          }
        });
      });
    }

    toggleDropdown(toggle, dropdown) {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.closeDropdown(toggle, dropdown);
      } else {
        this.closeAllDropdowns();
        this.openDropdown(toggle, dropdown);
      }
    }

    openDropdown(toggle, dropdown) {
      toggle.setAttribute('aria-expanded', 'true');
      dropdown.setAttribute('aria-hidden', 'false');
      toggle.classList.add('is-open');
      dropdown.classList.add('is-open');
      if (this.shouldPositionFlyouts()) {
        this.positionDropdown(toggle, dropdown);
      }
    }

    closeDropdown(toggle, dropdown) {
      toggle.setAttribute('aria-expanded', 'false');
      dropdown.setAttribute('aria-hidden', 'true');
      toggle.classList.remove('is-open');
      dropdown.classList.remove('is-open');
      this.closeAllNestedDropdowns();
    }

    positionDropdown(toggle, dropdown) {
      dropdown.classList.remove('navbar__dropdown--right-aligned');

      requestAnimationFrame(() => {
        const viewportWidth = window.innerWidth;
        const toggleRect = toggle.getBoundingClientRect();
        const dropdownWidth = dropdown.offsetWidth;
        const margin = 20;

        const rightEdgePosition = toggleRect.left + dropdownWidth;
        const wouldOverflowRight = rightEdgePosition > viewportWidth - margin;

        const hasSpaceForRightAlign =
          toggleRect.right >= dropdownWidth + margin;

        if (wouldOverflowRight && hasSpaceForRightAlign) {
          dropdown.classList.add('navbar__dropdown--right-aligned');
        }
      });
    }

    closeAllDropdowns() {
      const dropdownToggles = this.root.querySelectorAll(
        '[data-dropdown-toggle]'
      );
      dropdownToggles.forEach((toggle) => {
        const dropdown = toggle.nextElementSibling;
        if (dropdown) this.closeDropdown(toggle, dropdown);
      });

      this.closeAllNestedDropdowns();
    }

    initNestedDropdowns() {
      const nestedDropdownToggles = this.root.querySelectorAll(
        '[data-nested-dropdown-toggle]'
      );

      nestedDropdownToggles.forEach((toggle) => {
        const nestedDropdown = toggle.nextElementSibling;
        const dropdownItem = toggle.parentElement;
        let hoverTimeout;

        if (!nestedDropdown) return;

        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleNestedDropdown(toggle, nestedDropdown);
        });

        dropdownItem.addEventListener('mouseenter', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
          this.closeOtherNestedDropdowns(toggle);
          hoverTimeout = setTimeout(() => {
            this.openNestedDropdown(toggle, nestedDropdown);
          }, DROPDOWN_CLOSE_DELAY_MS);
        });

        dropdownItem.addEventListener('mouseleave', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
          hoverTimeout = setTimeout(() => {
            this.closeNestedDropdown(toggle, nestedDropdown);
          }, NESTED_DROPDOWN_CLOSE_DELAY_MS);
        });

        nestedDropdown.addEventListener('mouseenter', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
        });

        nestedDropdown.addEventListener('mouseleave', () => {
          if (!this.shouldUseHoverFlyouts()) return;
          clearTimeout(hoverTimeout);
          hoverTimeout = setTimeout(() => {
            this.closeNestedDropdown(toggle, nestedDropdown);
          }, NESTED_DROPDOWN_CLOSE_DELAY_MS);
        });

        toggle.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleNestedDropdown(toggle, nestedDropdown);
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            this.openNestedDropdown(toggle, nestedDropdown);
            const firstLink = nestedDropdown.querySelector(
              '.navbar__nested-dropdown-link'
            );
            if (firstLink) firstLink.focus();
          } else if (event.key === 'Escape') {
            this.closeNestedDropdown(toggle, nestedDropdown);
          }
        });

        const nestedLinks = nestedDropdown.querySelectorAll(
          '.navbar__nested-dropdown-link'
        );
        nestedLinks.forEach((link, index) => {
          link.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown') {
              event.preventDefault();
              const nextLink = nestedLinks[index + 1];
              if (nextLink) nextLink.focus();
            } else if (event.key === 'ArrowUp') {
              event.preventDefault();
              if (index === 0) {
                toggle.focus();
              } else {
                const prevLink = nestedLinks[index - 1];
                if (prevLink) prevLink.focus();
              }
            } else if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.closeNestedDropdown(toggle, nestedDropdown);
              toggle.focus();
            } else if (event.key === 'Escape') {
              event.preventDefault();
              this.closeNestedDropdown(toggle, nestedDropdown);
              toggle.focus();
            }
          });
        });
      });
    }

    toggleNestedDropdown(toggle, nestedDropdown) {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.closeNestedDropdown(toggle, nestedDropdown);
      } else {
        this.closeOtherNestedDropdowns(toggle);
        this.openNestedDropdown(toggle, nestedDropdown);
      }
    }

    openNestedDropdown(toggle, nestedDropdown) {
      toggle.setAttribute('aria-expanded', 'true');
      nestedDropdown.setAttribute('aria-hidden', 'false');
      toggle.classList.add('is-open');
      nestedDropdown.classList.add('is-open');
      if (this.shouldPositionFlyouts()) {
        this.positionNestedDropdown(toggle, nestedDropdown);
      }
    }

    closeNestedDropdown(toggle, nestedDropdown) {
      toggle.setAttribute('aria-expanded', 'false');
      nestedDropdown.setAttribute('aria-hidden', 'true');
      toggle.classList.remove('is-open');
      nestedDropdown.classList.remove('is-open');
    }

    positionNestedDropdown(toggle, nestedDropdown) {
      nestedDropdown.classList.remove('navbar__nested-dropdown--left');

      requestAnimationFrame(() => {
        const viewportWidth = window.innerWidth;
        const toggleRect = toggle.getBoundingClientRect();
        const dropdownWidth = nestedDropdown.offsetWidth;
        const margin = 20;

        const rightEdgePosition = toggleRect.right + dropdownWidth;
        const wouldOverflowRight = rightEdgePosition > viewportWidth - margin;
        const leftEdgePosition = toggleRect.left - dropdownWidth;
        const hasSpaceOnLeft = leftEdgePosition >= margin;

        if (wouldOverflowRight && hasSpaceOnLeft) {
          nestedDropdown.classList.add('navbar__nested-dropdown--left');
        }
      });
    }

    closeOtherNestedDropdowns(currentToggle) {
      const parentDropdown = currentToggle.closest('.navbar__dropdown-content');
      if (!parentDropdown) return;

      const otherToggles = parentDropdown.querySelectorAll(
        '[data-nested-dropdown-toggle]'
      );
      otherToggles.forEach((toggle) => {
        if (toggle === currentToggle) return;
        const nestedDropdown = toggle.nextElementSibling;
        if (nestedDropdown) this.closeNestedDropdown(toggle, nestedDropdown);
      });
    }

    closeAllNestedDropdowns() {
      const nestedDropdownToggles = this.root.querySelectorAll(
        '[data-nested-dropdown-toggle]'
      );
      nestedDropdownToggles.forEach((toggle) => {
        const nestedDropdown = toggle.nextElementSibling;
        if (nestedDropdown) this.closeNestedDropdown(toggle, nestedDropdown);
      });
    }
  }

  const initializedMenus = new WeakSet();

  function initDynamicMenus(context = document) {
    const roots = context.querySelectorAll('[data-dynamic-menu]');
    roots.forEach((root) => {
      if (initializedMenus.has(root)) return;
      initializedMenus.add(root);
      new DynamicMenuBlock(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDynamicMenus();
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event && event.target) {
      initDynamicMenus(event.target);
      return;
    }

    initDynamicMenus();
  });

  document.addEventListener('shopify:block:select', (event) => {
    if (event && event.target) {
      initDynamicMenus(event.target.closest('[data-dynamic-menu]') || document);
    }
  });
})();
